<template>
  <div class="navigation-products-item-fi">
    <cloud-image-fi
      v-if="item.thumbnailUrl?.Url"
      :src="item.thumbnailUrl.Url"
      :width="imageSize"
      :height="imageSize"
      params="func=fit"
      trim
      class="navigation-products-item-fi__image"
      alt="teaser image"
      do-not-replace-url
    />
    {{ item.CategoryName }}
  </div>
</template>

<script setup lang="ts">
import { CloudImageFi } from 'atoms';
import { computed } from 'vue';

import { useBreakpoints } from '@/composables/breakpoint';
import type { GetAllCategoriesQuery } from '@/generated/graphql';

defineOptions({ name: 'NavigationProductsItemFi' });

type NavigationCategory = NonNullable<
  NonNullable<GetAllCategoriesQuery['getAllCategories']>[number]
>;

interface Props {
  item: NavigationCategory;
}

defineProps<Props>();

const { isMD, isXL } = useBreakpoints();

const imageSize = computed(() => {
  if (isMD.value) {
    return '60';
  }

  if (isXL.value) {
    return '72';
  }

  return '54';
});
</script>

<style scoped src="./navigation-products-item-fi" />
